import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import { img } from "@/lib/images";
import { LocalizedLink } from "@/i18n/language";

const agbSections = [
  "1", "2", "3a", "3b", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13",
] as const;

export default function ImpressumPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar />
      <main>
        <PageHeader
          eyebrow={t("impressum_eyebrow")}
          title={t("impressum_title")}
          subtitle={t("impressum_intro")}
          image={img("legal-pages/header-legal-01.jpg")}
          imageAlt="Impressum Bali VW Tour"
        />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-8">
            {/* Last updated */}
            <div className="flex items-center gap-2 mb-6 text-sm text-foreground-600">
              <span className="w-5 h-5 flex items-center justify-center text-accent-700">
                <i className="ri-calendar-check-line text-base"></i>
              </span>
              <span>{t("impressum_updated")}</span>
            </div>

            <div className="space-y-8">
            {/* Section: Impressum */}
            <div className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">
                {t("impressum_sec_title")}
              </h2>
              <div className="w-10 h-0.5 bg-accent-500 mb-6"></div>
              <div className="text-sm md:text-base text-foreground-700 leading-relaxed whitespace-pre-line">
                {t("impressum_sec_text")}
              </div>
            </div>

            {/* Section: Haftungsausschluss */}
            <div className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">
                {t("disclaimer_title")}
              </h2>
              <div className="w-10 h-0.5 bg-accent-500 mb-6"></div>
              <div className="space-y-6">
                <div>
                  <h3 className="font-heading text-lg text-foreground-900 mb-2">
                    {t("disclaimer_contents_title")}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed whitespace-pre-line">
                    {t("disclaimer_contents_text")}
                  </p>
                </div>
                <div>
                  <h3 className="font-heading text-lg text-foreground-900 mb-2">
                    {t("disclaimer_links_title")}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed whitespace-pre-line">
                    {t("disclaimer_links_text")}
                  </p>
                </div>
                <div>
                  <h3 className="font-heading text-lg text-foreground-900 mb-2">
                    {t("disclaimer_copyright_title")}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed whitespace-pre-line">
                    {t("disclaimer_copyright_text")}
                  </p>
                </div>
              </div>
            </div>

            {/* Section: AGB */}
            <div className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">
                {t("agb_header")}
              </h2>
              <div className="w-10 h-0.5 bg-accent-500 mb-6"></div>
              <div className="space-y-8">
                {agbSections.map((key) => (
                  <div key={key}>
                    <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">
                      {t(`agb_${key}_title`)}
                    </h3>
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed whitespace-pre-line">
                      {t(`agb_${key}_text`)}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Datenschutz-Verweis */}
            <div className="bg-secondary-50 border border-secondary-200 rounded-lg p-6 md:p-8 flex flex-col sm:flex-row sm:items-center gap-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-900 text-xl flex-shrink-0">
                <i className="ri-lock-2-line"></i>
              </span>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {t("agb_privacy_note")}{" "}
                <LocalizedLink to="/privacy" className="text-primary-600 font-medium underline underline-offset-2 hover:text-primary-700 cursor-pointer">
                  {t("agb_privacy_link")}
                </LocalizedLink>
              </p>
            </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}